import { useSignal, useSignalEffect } from '@preact/signals-react';
import { useTranslation } from 'react-i18next';
import { ASSESSMENT_SUBJECT_SELF } from 'components/Assessment/Subject';

/**
 * Derive a className based on the give base className
 */
function deriveClassNameFrom(baseClassName, className) {
  if (baseClassName === '') {
    baseClassName = 'assessment-considerations';
  }
  return `${baseClassName}__${className}`;
}

function listItems(className, items, defaultValues, onUpdate = () => {}) {
  const deriveClassName = deriveClassNameFrom.bind(null, className);
  return items.map((item, index) => {
    const remarks = (item.remarks != '') ? ` (${item.remarks})` : '';
    return (
      <li key={index} className={deriveClassName('list__item')}>
        <label className={deriveClassName('list__item__field')}>
          <input
            className={deriveClassName('list__item__field__input')}
            type="checkbox"
            onChange={(e) => onUpdate(item.id, e.target.checked)}
            checked={defaultValues.includes(item.id)}
          />
          <span
            className={deriveClassName('list__item__field__label_title')}
          >
            {item.title}{remarks}
          </span>
        </label>
      </li>
    );
  });
}

export function AssessmentConsiderations({
  assessmentSubject,
  availableValues = [],
  defaultValues = [],
  onAnswer = () => {},
  className = '',
}) {
  const { t } = useTranslation();
  const deriveClassName = deriveClassNameFrom.bind(null, className);
  const selectedList = useSignal(defaultValues);

  useSignalEffect(() => {
    onAnswer(selectedList.value);
  });

  const list = listItems(
    className,
    availableValues,
    selectedList.value,
    (id, checked) => {
      if (checked) {
        selectedList.value = [...selectedList.value, id];
      } else {
        selectedList.value = [...selectedList.value.filter((item) => item !== id)];
      }
    },
  );
  return (
    <div className={className}>
      <p>{ t(
        assessmentSubject.value === ASSESSMENT_SUBJECT_SELF
          ? 'have you considered the following aspects'
          : `have the assessment subject considered the following aspects`
      ) }</p>
      <ul className={deriveClassName('list')}>
        {list}
      </ul>
    </div>
  );
}

export default AssessmentConsiderations;
